import mixpanel from 'mixpanel-browser';

import { UTM_KEYS, UTM_STORAGE_KEY } from '@lib/core/service/utils/captureUtmToStorage';

/**
 * Reads UTM from sessionStorage (saved at launch by ServiceLauncher before any redirect)
 * and registers them as Mixpanel super properties.
 */
export const registerUtmFromStorage = (): void => {
  if (typeof window === 'undefined') return;
  try {
    const saved = sessionStorage.getItem(UTM_STORAGE_KEY);
    if (!saved) return;
    const parsed = JSON.parse(saved) as Record<string, string>;
    const utmProps: Record<string, string> = {};
    UTM_KEYS.forEach(key => {
      if (parsed[key] && typeof parsed[key] === 'string') utmProps[key] = parsed[key];
    });
    if (Object.keys(utmProps).length) mixpanel.register(utmProps);
  } catch {
    // ignore
  }
};
